// class SDSColoursSemantic {
// 	static readonly primary = "#0b5fff";
// 	static readonly primaryDark = "#0a3d99";
// 	static readonly primaryLight = "#0b5fff";
// 	static readonly primaryText = "#ffffff";
// 	static readonly secondary = "#ff5f0b";
// 	static readonly secondaryDark = "#993d0a";
// 	static readonly secondaryLight = "#ff5f0b";
// 	static readonly secondaryText = "#ffffff";
// 	static readonly background = "#ffffff";
// 	static readonly surface = "#ffffff";
// 	static readonly error = "#b00020";
// 	static readonly onPrimary = "#ffffff";
// 	static readonly onSecondary = "#000000";
// 	static readonly onBackground = "#000000";
// 	static readonly onSurface = "#000000";
// 	static readonly onError = "#ffffff";
// 	static readonly textPrimaryOnBackground = "#000000";
// 	static readonly textSecondaryOnBackground = "#5f6368";
// 	static readonly textHintOnBackground = "#5f6368";
// 	static readonly textDisabledOnBackground = "#5f6368";
// 	static readonly textIconOnBackground = "#ffffff";
// 	static readonly textPrimaryOnLight = "#000000";
// 	static readonly textSecondaryOnLight = "#5f6368";
// 	static readonly textHintOnLight = "#5f6368";
// 	static readonly textDisabledOnLight = "#5f6368";
// 	static readonly textIconOnLight = "#ffffff";
// 	static readonly textPrimaryOnDark = "#ffffff";
// 	static readonly textSecondaryOnDark = "#ffffff";
// 	static readonly textHintOnDark = "#ffffff";
// 	static readonly textDisabledOnDark = "#ffffff";
// 	static readonly textIconOnDark = "#ffffff";
// 	static readonly textLinkOnLight = "#1155cc";
// 	static readonly textLinkOnDark = "#66b3ff";
// 	static readonly textLinkOnPrimary = "#66b3ff";
// 	static readonly textLinkOnSecondary = "#ff8c1a";
// 	static readonly textLinkOnBackground = "#1155cc";
// 	static readonly textLinkOnSurface = "#1155cc";
// 	static readonly textLinkDisabledOnLight = "#a6c8ff";
// 	static readonly textLinkDisabledOnDark = "#1a1a1a";
// 	static readonly textLinkDisabledOnPrimary = "#1a1a1a";
// 	static readonly textLinkDisabledOnSecondary = "#ff8c1a";
// 	static;
// }

export class SDSColorPrimitives {
    static bloodyBlue = '#1C2D46';
    static boringBlue = '#405D88';
    static brilliantBlue = '#6BE6EE';
    static pretentiousPurple = '#AF53F7';
    static offWhite = '#F5F0EC';
    static pureWhite = '#FFFFFF';
    static tardyTeal = '#179f97';
    static yawningYellow = '#FFD600';
}

export class SDSColorsSemantic {
    static background = SDSColorPrimitives.offWhite;
    static surface = SDSColorPrimitives.pureWhite;
    static onBackgroundPrimary = SDSColorPrimitives.bloodyBlue;
    static onBackgroundSecondary = SDSColorPrimitives.boringBlue;
    static brandPrimary = SDSColorPrimitives.tardyTeal;
    static brandSecondary = SDSColorPrimitives.yawningYellow;
    static brandTertiary = SDSColorPrimitives.pretentiousPurple;
}
